// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3WIEQ","tab":"ProcedureTabs_tab__2XBF6"};